import axios from "axios";
import useAuthStore from "@/stores/auth";

export default ({ requiresAuth = true, path = "auth" } = {}) => {
  const auth = useAuthStore().$state.token;

  let baseURL = "";
  switch (path) {
    case "auth":
      baseURL = import.meta.env.VITE_AUTH_BASE_URL;
      break;
    case "docs":
      baseURL = import.meta.env.VITE_DOCUMENTS_BASE_URL;
      break;
    case "signer":
      baseURL = import.meta.env.VITE_SIGN_BASE_URL;
      break;
    case "skck":
      baseURL = import.meta.env.VITE_SKCK_BASE_URL;
      break;
    default:
      baseURL = path;
  }

  const options = {
    baseURL,
    headers: {
      "app_id": import.meta.env.VITE_APP_ID,
      "app_key": import.meta.env.VITE_APP_KEY,
    },
  };

  if (requiresAuth && auth) {
    options.headers.Authorization = `Bearer ${auth}`;
  }

  const http = axios.create(options);

  return http;
};
